import * as React from 'react';
import swal from 'sweetalert';
import Table from '@mui/material/Table';
import { useDispatch } from "react-redux";
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { deleteUser,updateUserEndDate } from '../api/userapi';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
// import Switch from '@mui/material/Switch';
// import { styled } from '@mui/material/styles';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Select, Stack } from '@mui/material';
import EventIcon from '@mui/icons-material/Event';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import { useSelector } from 'react-redux'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
dayjs.extend(utc);
const columns = [
  { id: 'name', label: 'Name' },
  { id: 'email', label: 'Email'},
  { id: 'company', label: 'Company/Distributor Name',width: 250 },
  { id: 'group_name', label: 'Okta Group Name',width: 200 },
  { id: 'rolename', label: 'Rehlink Role' },
  { id: 'end_date', label: 'End Date' },
];


export default function AppUserItem({
  rowsPerPage,
  page,
  handleChangePage,
  handleChangeRowsPerPage,
  users,
  //handlePermissionDialogOpen,
  roleList,
  handleRoleChange,
  userType
}) {

  const dispatch                = useDispatch();
  const [open, setOpen]         = React.useState(false);
  const [tempDate, setTempDate] = React.useState(null);
  const [userId, setUserId]     = React.useState(null);
  const loggedUserInfo          = useSelector((state) => state.userPermissionRoleData.userPermissionsRolesInfo);

  const handleDelete = (userId) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to Delete User!",
      icon: "warning",
      buttons: ["Cancel", "OK"],
    })
    .then(willDelete => {
      if (willDelete) {
        dispatch(deleteUser(userType,userId,page));
      }
    });
  };

  const handleOpen = (endDate,userId) => {
    setTempDate(endDate ? dayjs(endDate) : null);
    setUserId(userId);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setUserId(null);
    setTempDate(null);
  };

  const handleSave = async () => {
    dispatch(updateUserEndDate(userType,userId,dayjs.utc(tempDate).format('YYYY-MM-DD'),page));
    handleClose();
  };


  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>      
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {users?.records?.length > 0 ? users?.records.map((row,i) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                  {columns.map((column) => {
                    const value = row[column.id];
                    return (
                      <TableCell key={column.id} align={column.align} width={column.width}>
                        {column.format && typeof value === 'number'
                          ? column.format(value) 
                          : column.id === 'rolename'?
                            <Select
                              key={row.id}
                              style={{ width: 180 }}
                              labelId="demo-select-small-label"
                              id="demo-select-small"
                              value={roleList?.length > 0 ?  row?.roleId || '' : ''} 
                              //label="Roles"       
                              onChange={(event) => handleRoleChange(event,row.id)}
                              defaultValue=""
                            >
                            
                            {loggedUserInfo?.data?.userDetails?.role_id !== 1 &&
                              roleList?.map((role) => (
                                <MenuItem disabled={role.id === 7 || role.id === 8} key={role.id} value={role.id}>
                                  {role.name}
                                </MenuItem>
                            ))}

                            {loggedUserInfo?.data?.userDetails?.role_id === 1 &&
                              roleList?.map((role) => (
                                <MenuItem key={role.id} value={role.id}>
                                  {role.name}
                                </MenuItem>
                            ))}

                            </Select>
                          // : column.id === 'is_active' ?
                            // <AntSwitch
                            //     value={row.id || ''}
                            //     key={row.id}
                            //     checked={row.is_active ? true : false}
                            //     onChange={(event) => handleSwitchChange(event,row.id)} 
                            // />
                          : column.id === 'actions' ?
                            <IconButton
                                onClick={(e)=> handleDelete(row.id)}
                            >
                                <DeleteIcon color="error" />
                            </IconButton>
                            :column.id === 'end_date' ?
                            
                              <IconButton
                                aria-label="choose date"
                                sx={{color:'#000'}}
                                onClick={() => handleOpen(row.end_date,row.id)}
                                size="medium"
                              >
                                <EventIcon />
                              </IconButton>

                          : value
                          }
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            }) : <TableRow><TableCell colSpan={6}>No Data Available. </TableCell></TableRow>}
          </TableBody>
        </Table>
      </TableContainer>
      {users?.total > 0 ?
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={users?.total}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage} />
        : <></>
      }
      
      {/* Dialog with DatePicker */}
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
        <DialogTitle>Select End date</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2} sx={{ mt: 1 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              minDate={dayjs.utc().startOf("day")}
              maxDate={dayjs.utc().add(4, 'year')}
              value={tempDate}
              onChange={(newVal) => setTempDate(newVal)}
              format="YYYY-MM-DD"
              slotProps={{
                textField: {
                  size: 'medium',
                  fullWidth: true,
                  readOnly: true,
                },
              }}
            />
            </LocalizationProvider>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color='error'  variant="contained">Cancel</Button>
          <Button onClick={handleSave} variant="contained" disabled={!tempDate}>
            Save
          </Button>
        </DialogActions>
      </Dialog>

    </Paper>  
  );
}